module.exports = __webpack_public_path__ + "img/customer_Wechat.7ca0699c.png";